/**
 * `/` — the app's home: Pulpit, the trainer's dashboard.
 *
 * The session's routing table sends every live session here (`routeForSessionStatus` in
 * `entities/session`), so this is the first screen a signed-in trainer sees.
 *
 * It was the client roster until 23 September 2026, when the owner moved the landing page to the
 * dashboard. The roster moved to `/klienci`, beside the client detail and the archive it already
 * led to, and `/pulpit`, the dashboard's address since 15 September, redirects here so a bookmark
 * of it still lands.
 */

import { createFileRoute } from '@tanstack/react-router';

import { TrainerHomeScreen } from '~/pages/trainer-home';

export const Route = createFileRoute('/_shell/')({
  component: TrainerHomeScreen,
});
